import { useState, useEffect, useRef } from "react";
import { ReportStatusType } from "../../../types";
import {
  reportStatusOptions,
  reportStatusStyles,
} from "../../SubmitTip/resources";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

const ReportStatusSelector = ({
  reportStatus,
  setReportStatus,
  options = reportStatusOptions,
  simpleView = false,
  disabled = false,
  disbaleDropdown = false,
}: ReportStatusSelectorProps) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOption = (value: ReportStatusType | undefined) => {
    if (setReportStatus) {
      setReportStatus(value);
      setOpen(false);
    }
  };

  const handleClickAway = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickAway);
    } else {
      document.removeEventListener("mousedown", handleClickAway);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickAway);
    };
    // eslint-disable-next-line
  }, [open]);

  return (
    <div
      className="relative flex flex-col items-start justify-start gap-1 w-full cursor-pointer"
      ref={dropdownRef}
    >
      <div
        className={`flex gap-2 items-start  ${
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
        onClick={() => !disabled && setOpen((prev) => !prev)}
      >
        {!simpleView && (
          <p
            className={`font-[600] text-base leading-5 ${
              disabled ? "text-gray-3" : "text-gray-7"
            }`}
          >
            Status:
          </p>
        )}

        <div className="flex items-center gap-1.5 w-full">
          <span
            className={`rounded-3xl py-1 px-2 sm:px-3 font-[600] text-[8px] sm:text-[10px] leading-3 ${
              reportStatusStyles[reportStatus || "submitted"]
            } ${disabled ? "text-white !bg-gray-4" : "text-gray-7"}`}
          >
            {(reportStatus || "All").toUpperCase()}
          </span>
          {!simpleView && (
            <>
              {open ? (
                <FaChevronUp
                  size={12}
                  color={disabled ? "#BCBCBC" : "#131313"}
                />
              ) : (
                <FaChevronDown
                  size={12}
                  color={disabled ? "#BCBCBC" : "#131313"}
                />
              )}
            </>
          )}
        </div>
      </div>

      {!disbaleDropdown && open && (
        <div className="absolute top-[28px] z-10 w-[181px] flex flex-col bg-white rounded-[12px] p-2 shadow-selectMenu-status">
          {options.map((option, i) => (
            <div
              className="py-[13px] px-3 text-[14px] leading-4 font-medium hover:bg-gray-2"
              onClick={() => handleClickOption(option.value)}
              key={i}
            >
              {option.label.toUpperCase()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReportStatusSelector;

type ReportStatusSelectorProps = {
  reportStatus: ReportStatusType | undefined;
  setReportStatus?: (value: ReportStatusType | undefined) => void;
  options?: { label: string; value: ReportStatusType | undefined }[];
  simpleView?: boolean;
  disabled?: boolean;
  disbaleDropdown?: boolean;
};
